import styled from "styled-components";

export const MainContainer = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  gap: 1rem;
  align-items: center;
`;
